module.exports = __webpack_public_path__ + "img/Weapon_247.044c5869.png";